import type {FondFieldRelationLink} from 'src/features/record/kp-related-records-table/types';
import {getContext, setContext} from 'svelte';

const relationsContextKey = 'relations-context-key';

export interface RelationsContext {
    relations: FondFieldRelationLink[];
}

export function createRelationsContext(relations: FondFieldRelationLink[]): RelationsContext {
    return setContext<RelationsContext>(relationsContextKey, {
        relations
    });
}

export function getRelationsContext(): RelationsContext {
    return getContext<RelationsContext>(relationsContextKey);
}